import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChartWaterfall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChartWaterfall"><Path d="M22 20H2V18.5H22V20Z" fill="currentColor"/><Path d="M4.75 15H3.25V11H4.75V15Z" fill="currentColor"/><Path d="M20.75 15H19.25V4H20.75V15Z" fill="currentColor"/><Path d="M8.75 13H7.25V6H8.75V13Z" fill="currentColor"/><Path d="M12.75 13H11.25V9H12.75V13Z" fill="currentColor"/><Path d="M16.75 10H15.25V5H16.75V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChartWaterfall;
